import { __decorate, __metadata } from "tslib";
import { isNil } from '@antv/util';
import { inject, singleton } from 'mana-syringe';
import { ElementEvent } from '../dom';
import { INHERIT_PROPERTIES } from '../global-module';
import { computeInheritStyleProperty } from '../property-handlers';
import { RenderingContext, RenderReason, RenderingPluginContribution, dirtifyToRoot } from '../services';

var PrepareRendererPlugin =
/** @class */
function () {
  function PrepareRendererPlugin() {}

  PrepareRendererPlugin_1 = PrepareRendererPlugin;

  PrepareRendererPlugin.prototype.apply = function (renderingService) {
    var _this = this;

    var handleAttributeChanged = function handleAttributeChanged() {
      _this.renderingContext.renderReasons.add(RenderReason.DISPLAY_OBJECT_CHANGED);
    };

    var handleBoundsChanged = function handleBoundsChanged() {
      renderingService.dirtify();
    };

    var handleMounted = function handleMounted(e) {
      var object = e.target; // compute some style when mounted

      INHERIT_PROPERTIES.forEach(function (name) {
        if (object.getAttribute(name) === 'inherit') {
          var computedValue = computeInheritStyleProperty(object, name);

          if (!isNil(computedValue)) {
            var oldParsedValue = object.parsedStyle[name];
            object.parsedStyle[name] = computedValue;
            object.updateStyleProperty(name, oldParsedValue, computedValue);
          }
        }
      });
      dirtifyToRoot(object);
      renderingService.dirtify();
    };

    var handleUnmounted = function handleUnmounted(e) {
      dirtifyToRoot(e.target);
      renderingService.dirtify();
    };

    renderingService.hooks.init.tap(PrepareRendererPlugin_1.tag, function () {
      _this.renderingContext.root.addEventListener(ElementEvent.MOUNTED, handleMounted);

      _this.renderingContext.root.addEventListener(ElementEvent.UNMOUNTED, handleUnmounted);

      _this.renderingContext.root.addEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);

      _this.renderingContext.root.addEventListener(ElementEvent.BOUNDS_CHANGED, handleBoundsChanged);
    });
    renderingService.hooks.destroy.tap(PrepareRendererPlugin_1.tag, function () {
      _this.renderingContext.root.removeEventListener(ElementEvent.MOUNTED, handleMounted);

      _this.renderingContext.root.removeEventListener(ElementEvent.UNMOUNTED, handleUnmounted);

      _this.renderingContext.root.removeEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);

      _this.renderingContext.root.removeEventListener(ElementEvent.BOUNDS_CHANGED, handleBoundsChanged);
    });
  };

  var PrepareRendererPlugin_1;
  PrepareRendererPlugin.tag = 'PrepareRendererPlugin';

  __decorate([inject(RenderingContext), __metadata("design:type", Object)], PrepareRendererPlugin.prototype, "renderingContext", void 0);

  PrepareRendererPlugin = PrepareRendererPlugin_1 = __decorate([singleton({
    contrib: RenderingPluginContribution
  })], PrepareRendererPlugin);
  return PrepareRendererPlugin;
}();

export { PrepareRendererPlugin };